// ? Search for icons: https://react-icons.github.io/react-icons/search
import {
  FaExclamationTriangle,
  FaInfo,
  FaLightbulb,
  FaThumbsUp
} from 'react-icons/fa'

import { getBlockQuoteType } from './helpers'

export function getBlockQuoteIcon (blockQuote) {
  const type = getBlockQuoteType(blockQuote)

  switch (type) {
    case 'note':
      return FaInfo
    case 'warning':
      return FaExclamationTriangle
    case 'bestPractise':
      return FaThumbsUp
    case 'tip':
      return FaLightbulb
    default:
      return () => { }
  }
}
